import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function CrossoverArrowsRight({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>CrossoverArrowsRight</title>
      <path
        d="M5 19L19 5M19 5L19 9M19 5L15 5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5L8.5 8.5L9.375 9.375M19 19L15 19M19 19L19 15M19 19L15.5 15.5L14.625 14.625"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
